module.exports = __webpack_public_path__ + "img/image2.d14b9ac3.png";